<template>
  <div>
    <b-message type="is-info" class="is-size-7">
      Confirm the shipping address associated with your FedEx account for validation.
    </b-message>
    <b-field label="Name">
      <b-input v-model="form.name" size="is-medium" @input="announce" />
    </b-field>
    <b-field label="Street">
      <b-input v-model="form.street1" size="is-medium" @input="announce" />
    </b-field>
    <div class="columns">
      <div class="column is-half">
        <b-field label="City">
          <b-input v-model="form.city" size="is-medium" @input="announce" />
        </b-field>
      </div>
      <div class="column is-half">
        <b-field label="State">
          <b-input v-model="form.state" size="is-medium" @input="announce" />
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column is-half">
        <b-field label="Postal Code">
          <b-input v-model="form.postal_code" size="is-medium" @input="announce" />
        </b-field>
      </div>
      <div class="column is-half">
        <b-field label="Country">
          <b-input v-model="form.country" size="is-medium" placeholder="e.g. US" maxlength="3" @input="announce" />
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    prefill: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      form: {
        name: null,
        street1: this.prefill ? this.prefill.street1 : null,
        city: this.prefill ? this.prefill.city : null,
        state: this.prefill ? this.prefill.state : null,
        postal_code: this.prefill ? this.prefill.zip : null,
        country: this.prefill ? this.prefill.country : null
      }
    }
  },
  computed: {
    valid () {
      return !!(this.form.name && this.form.street1 && this.form.city && this.form.state && this.form.postal_code && this.form.country)
    }
  },
  methods: {
    announce () {
      this.$emit('input', this.valid ? this.form : null)
    }
  }
}
</script>
